'use client';

import { LoadingBackground } from '@core/Components/LoadingBackground/LoadingBackground';
import Button from '@gds/Button/Button';
import { Typography } from '@gds/Typography/Typography';

import type { CalculatorMessages } from '../Calculator.messages';

import styles from './../Calculator.module.css';

export type Props = {
  strings: CalculatorMessages;
  hasReservedStatus?: boolean;
};

export const LoadingSummaryContainer = ({ strings }: Props) => (
  <div className={styles.summaryContainer}>
    <div className={styles.summaryTitle}>
      <Typography variant="h5">
        <LoadingBackground />
      </Typography>

      <Typography variant="body4" Component="p">
        <LoadingBackground />
      </Typography>
    </div>
    <div className={styles.fakeSummary}>
      <LoadingBackground />
    </div>
    <div className={styles.ctasContainer}>
      <Button variant="outlined" type="submit" disabled>
        {strings.submitToDealer}
      </Button>
    </div>
  </div>
);
